import { useMemo, useState } from 'react';
import { CustomTableSortItems } from 'commons/components/table/sort/custom-table-sorting.model';
import { OperatorCustomNotificationRow } from 'modules/settings/pods/settings-operator-custom-notifications/settings-operator-custom-notifications.model';
import { sortByStringField } from 'commons/utils/sort.utils';

const NO_SORT: CustomTableSortItems = {};

export const useOperatorCustomNotificationsSort = (rows: OperatorCustomNotificationRow[]) => {
    const [sortItems, setSortItems] = useState<CustomTableSortItems>(NO_SORT);

    const sortedRows = useMemo(() => sortByStringField(rows, sortItems, 'notificationName'), [rows, sortItems]);

    return { sortedRows, defaultSort: NO_SORT, onSortOrderChange: setSortItems };
};
